import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Star, Quote } from 'lucide-react';

const TestimonialsSection = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      text: 'BLS Paints transformed our home beautifully! The attention to detail and professionalism exceeded our expectations. Our living room looks absolutely stunning with the new texture finish.',
      author: 'Rajesh Sharma',
      location: 'Mumbai',
      rating: 5
    },
    {
      text: 'I was impressed by their punctuality and quality of work. They completed our office renovation ahead of schedule without compromising on quality. Highly recommended!',
      author: 'Priya Patel',
      location: 'Ahmedabad',
      rating: 5
    },
    {
      text: 'The color consultation service was invaluable. They helped us choose the perfect palette for our home. The final result is exactly what we envisioned. Thank you, BLS Paints!',
      author: 'Amit Desai',
      location: 'Surat',
      rating: 5
    },
    {
      text: 'Outstanding service from start to finish! The team was professional, clean, and respectful of our home. The exterior painting has made our house the talk of the neighborhood.',
      author: 'Meera Joshi',
      location: 'Pune',
      rating: 5
    },
    {
      text: 'We hired BLS Paints for our restaurant renovation and couldn\'t be happier. They understood our vision and delivered exceptional results within our budget. True professionals!',
      author: 'Vikram Singh',
      location: 'Mumbai',
      rating: 5
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 6000);

    return () => clearInterval(timer);
  }, [testimonials.length]);

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="testimonials-section section-padding">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">What Our Clients Say</h2>
          <p className="section-subtitle">Real Stories from Real Customers</p>
        </div>

        <div className="testimonials-slider">
          <button className="slider-button prev" onClick={prevTestimonial} aria-label="Previous testimonial">
            <ChevronLeft size={32} />
          </button>

          <div className="testimonial-content">
            <Quote className="quote-icon" size={48} />
            <div className="testimonial-card">
              <div className="stars">
                {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
                  <Star key={i} size={20} fill="currentColor" />
                ))}
              </div>
              <p className="testimonial-text">"{testimonials[currentTestimonial].text}"</p>
              <div className="testimonial-author">
                <div className="author-name">{testimonials[currentTestimonial].author}</div>
                <div className="author-location">{testimonials[currentTestimonial].location}</div>
              </div>
            </div>
          </div>

          <button className="slider-button next" onClick={nextTestimonial} aria-label="Next testimonial">
            <ChevronRight size={32} />
          </button>
        </div>

        {/* Slider Indicators */}
        <div className="slider-dots">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`slider-dot ${index === currentTestimonial ? 'active' : ''}`}
              onClick={() => setCurrentTestimonial(index)}
              aria-label={`Go to testimonial ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;